import React, { useState } from 'react';
import { copyShift } from '../actions';
import { useDispatch } from 'react-redux';

const CopyShiftButton = () => {
  const [shiftNumber, setShiftNumber] = useState(0);
  const dispatch = useDispatch();
  return (
    <span>
      <button onClick={() => dispatch(copyShift(shiftNumber))}>
        Copy Shift
      </button>
      &nbsp;&nbsp;&nbsp;
      <input
        type="text"
        name="shiftNumber"
        style={{ width: '50px' }}
        value={shiftNumber}
        onChange={(e) => setShiftNumber(e.target.value)}
      />
    </span>
  );
};

export default CopyShiftButton;
